module.exports = __webpack_public_path__ + "static/electric_solutions-c535200b30b24865296959d0e65c4212.png";